import './tablegrid.css';
import React from 'react';
import {DataTable} from '../table';

export const TableGrid=({
    data,
    setDynamicColumn,
    dynamicColumn, title,
    loading, viewRefetch, view, objectData,detailpage,handelBulkUpdateSave, noHeader=false,
    handelArchive, archiveLabel="Archive", handelDelete, clearSelection=false, detailbtn="Preview", detailUrl="", selectionAllowed=true,
    totalCount, currentPage, totalPages, setPageSize, setPage, pageSize, showSizeChanger=true,
    setSearch, search, onExportAll, onSortChange,
    // the properties' objectType, when the title isn't it (e.g. "Site Group" -> "SiteGroup")
    objectType
})=>{

    return (

            <div className='tableView'>
                <DataTable
                    data={data}
                    header={true}
                    setDynamicColumn={setDynamicColumn}
                    dynamicColumn={dynamicColumn}
                    loading={loading}
                    viewRefetch={viewRefetch}
                    view={view}
                    objectData={objectData}
                    detailpage={detailpage}
                    handelBulkUpdateSave={handelBulkUpdateSave}
                    noHeader={noHeader}
                    handelArchive={handelArchive}
                    archiveLabel={archiveLabel}
                    handelDelete={handelDelete}
                    clearSelection={clearSelection}
                    title={title}
                    detailbtn={detailbtn}
                    detailUrl={detailUrl}
                    selectionAllowed={selectionAllowed}
                    totalCount={totalCount}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    setPageSize={setPageSize}
                    setPage={setPage}
                    pageSize={pageSize}
                    showSizeChanger={showSizeChanger}
                    setSearch={setSearch}
                    search={search}
                    onExportAll={onExportAll}
                    onSortChange={onSortChange}
                    objectType={objectType}
                />
                
            </div>

            
    )
}